// extracted by mini-css-extract-plugin
export default {"contentBoarding":"Boarding_contentBoarding__r7k0r","boardingTypeGrid":"Boarding_boardingTypeGrid__oWjWs","col":"Boarding_col__-i5So"};